export default "__VITE_ASSET__BAA0vgV0__"